import React from 'react';
import { Link } from 'react-router-dom';
import styles from './sections.module.css';

const TrustSection = () => (
  <section className={`vxm-section ${styles.trustSection}`} id="trust">
    <div className={`vxm-container vxm-container--narrow ${styles.trustInner}`}>
      <p className="vxm-eyebrow">Security &amp; privacy</p>
      <h2 className="vxm-h2">Your network is sensitive data</h2>
      <p className="vxm-body">
        Private notes stay with the person who wrote them. Locations are not
        shown to administrators. Every bulk view of contact information is
        recorded.{' '}
        <Link to="/security-privacy" className="vxm-link">
          Read more about security and privacy
        </Link>
        .
      </p>
    </div>
  </section>
);

export default TrustSection;
